module.exports = __webpack_public_path__ + "img/Vector.44ac7155.svg";